import { default as about_45us9kiw2OpfgnMeta } from "/opt/build/repo/pages/about-us.vue?macro=true";
import { default as are_45you_45an_45agencyDKOlJF2RdSMeta } from "/opt/build/repo/pages/are-you-an-agency.vue?macro=true";
import { default as indexx3sznPgcaVMeta } from "/opt/build/repo/pages/blog/[slug]/index.vue?macro=true";
import { default as indexmFsYN4t0XfMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as indexXg4YC5iHhmMeta } from "/opt/build/repo/pages/careers/[slug]/index.vue?macro=true";
import { default as indexxwcF5y3IQqMeta } from "/opt/build/repo/pages/careers/index.vue?macro=true";
import { default as clinical_45areashjSfAxVoH6Meta } from "/opt/build/repo/pages/clinical-areas.vue?macro=true";
import { default as contactsQ2Ks7vPefgMeta } from "/opt/build/repo/pages/contacts.vue?macro=true";
import { default as indexSTbUvLZXiaMeta } from "/opt/build/repo/pages/contents/[slug]/index.vue?macro=true";
import { default as indexvKm4H3ohfUMeta } from "/opt/build/repo/pages/contents/index.vue?macro=true";
import { default as cookie_45policyZcRIsfqfIvMeta } from "/opt/build/repo/pages/cookie-policy.vue?macro=true";
import { default as indexQVKfM23LXdMeta } from "/opt/build/repo/pages/expertise/[slug]/index.vue?macro=true";
import { default as indexuZ1vNkriiyMeta } from "/opt/build/repo/pages/expertise/index.vue?macro=true";
import { default as form_45submission_45failureddjxJla3GJMeta } from "/opt/build/repo/pages/form-submission-failure.vue?macro=true";
import { default as form_45submission_45successk0ay3CQ3szMeta } from "/opt/build/repo/pages/form-submission-success.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as indexfqhiJ6ICreMeta } from "/opt/build/repo/pages/industries/[slug]/index.vue?macro=true";
import { default as indexxQdX3kdZZvMeta } from "/opt/build/repo/pages/industries/index.vue?macro=true";
import { default as indexlrvF1FAyXbMeta } from "/opt/build/repo/pages/lets-talk/index.vue?macro=true";
import { default as newsletter_45submission_45successlNdcLQOt6WMeta } from "/opt/build/repo/pages/newsletter-submission-success.vue?macro=true";
import { default as privacy_45policyQXTlhFuZ55Meta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as indexBmiOq17LApMeta } from "/opt/build/repo/pages/projects/[slug]/index.vue?macro=true";
import { default as indexxtMqaql9AYMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as richiedi_45progetto1Nn9GbgCcAMeta } from "/opt/build/repo/pages/richiedi-progetto.vue?macro=true";
import { default as index8lXtsvPro8Meta } from "/opt/build/repo/pages/solutions/[slug]/index.vue?macro=true";
import { default as indexSicrNAjcMxMeta } from "/opt/build/repo/pages/solutions/index.vue?macro=true";
import { default as indexuoDA5dcWGeMeta } from "/opt/build/repo/pages/technology/[slug]/index.vue?macro=true";
import { default as indexicFcACNNRXMeta } from "/opt/build/repo/pages/technology/index.vue?macro=true";
import { default as component_45stub0XN034Q7gBMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.0_@types+node@20.17.6_eslint@8.57.1_ioredis@5.4.1_magic_93f306684b83ba35082ddad2494f5bf6/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub0XN034Q7gB } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.0_@types+node@20.17.6_eslint@8.57.1_ioredis@5.4.1_magic_93f306684b83ba35082ddad2494f5bf6/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about-us___en",
    path: "/about-us",
    meta: about_45us9kiw2OpfgnMeta || {},
    component: () => import("/opt/build/repo/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___it",
    path: "/it/studio",
    meta: about_45us9kiw2OpfgnMeta || {},
    component: () => import("/opt/build/repo/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "are-you-an-agency___en",
    path: "/collaborations",
    meta: are_45you_45an_45agencyDKOlJF2RdSMeta || {},
    component: () => import("/opt/build/repo/pages/are-you-an-agency.vue").then(m => m.default || m)
  },
  {
    name: "are-you-an-agency___it",
    path: "/it/collaborazioni-tra-agenzie",
    meta: are_45you_45an_45agencyDKOlJF2RdSMeta || {},
    component: () => import("/opt/build/repo/pages/are-you-an-agency.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___en",
    path: "/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "careers-slug___en",
    path: "/careers/:slug()",
    meta: indexXg4YC5iHhmMeta || {},
    component: () => import("/opt/build/repo/pages/careers/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "careers-slug___it",
    path: "/it/careers/:slug()",
    meta: indexXg4YC5iHhmMeta || {},
    component: () => import("/opt/build/repo/pages/careers/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "careers___en",
    path: "/careers",
    meta: indexxwcF5y3IQqMeta || {},
    component: () => import("/opt/build/repo/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: "careers___it",
    path: "/it/careers",
    meta: indexxwcF5y3IQqMeta || {},
    component: () => import("/opt/build/repo/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: "clinical-areas___en",
    path: "/clinical-areas",
    meta: clinical_45areashjSfAxVoH6Meta || {},
    component: () => import("/opt/build/repo/pages/clinical-areas.vue").then(m => m.default || m)
  },
  {
    name: "clinical-areas___it",
    path: "/it/aree-terapeutiche",
    meta: clinical_45areashjSfAxVoH6Meta || {},
    component: () => import("/opt/build/repo/pages/clinical-areas.vue").then(m => m.default || m)
  },
  {
    name: "contacts___en",
    path: "/contacts",
    meta: contactsQ2Ks7vPefgMeta || {},
    component: () => import("/opt/build/repo/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___it",
    path: "/it/contatti",
    meta: contactsQ2Ks7vPefgMeta || {},
    component: () => import("/opt/build/repo/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contents-slug___en",
    path: "/contents/:slug()",
    meta: indexSTbUvLZXiaMeta || {},
    component: () => import("/opt/build/repo/pages/contents/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "contents-slug___it",
    path: "/it/contenuti/:slug()",
    meta: indexSTbUvLZXiaMeta || {},
    component: () => import("/opt/build/repo/pages/contents/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "contents___en",
    path: "/contents",
    meta: indexvKm4H3ohfUMeta || {},
    component: () => import("/opt/build/repo/pages/contents/index.vue").then(m => m.default || m)
  },
  {
    name: "contents___it",
    path: "/it/contenuti",
    meta: indexvKm4H3ohfUMeta || {},
    component: () => import("/opt/build/repo/pages/contents/index.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___en",
    path: "/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___it",
    path: "/it/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: "expertise-slug___en",
    path: "/expertise/:slug()",
    meta: indexQVKfM23LXdMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "expertise-slug___it",
    path: "/it/expertise/:slug()",
    meta: indexQVKfM23LXdMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "expertise___en",
    path: "/expertise",
    meta: indexuZ1vNkriiyMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/index.vue").then(m => m.default || m)
  },
  {
    name: "expertise___it",
    path: "/it/expertise",
    meta: indexuZ1vNkriiyMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/index.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-failure___en",
    path: "/form-submission-failure",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-failure___it",
    path: "/it/invio-modulo-fallito",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-success___en",
    path: "/form-submission-success",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "form-submission-success___it",
    path: "/it/invio-modulo-completato",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "industries-slug___en",
    path: "/industries/:slug()",
    meta: indexfqhiJ6ICreMeta || {},
    component: () => import("/opt/build/repo/pages/industries/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "industries-slug___it",
    path: "/it/settori/:slug()",
    meta: indexfqhiJ6ICreMeta || {},
    component: () => import("/opt/build/repo/pages/industries/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "industries___en",
    path: "/industries",
    meta: indexxQdX3kdZZvMeta || {},
    component: () => import("/opt/build/repo/pages/industries/index.vue").then(m => m.default || m)
  },
  {
    name: "industries___it",
    path: "/it/settori",
    meta: indexxQdX3kdZZvMeta || {},
    component: () => import("/opt/build/repo/pages/industries/index.vue").then(m => m.default || m)
  },
  {
    name: "lets-talk___en",
    path: "/lets-talk",
    meta: indexlrvF1FAyXbMeta || {},
    component: () => import("/opt/build/repo/pages/lets-talk/index.vue").then(m => m.default || m)
  },
  {
    name: "lets-talk___it",
    path: "/it/lets-talk",
    meta: indexlrvF1FAyXbMeta || {},
    component: () => import("/opt/build/repo/pages/lets-talk/index.vue").then(m => m.default || m)
  },
  {
    name: "newsletter-submission-success___en",
    path: "/newsletter-subscription-success",
    meta: newsletter_45submission_45successlNdcLQOt6WMeta || {},
    component: () => import("/opt/build/repo/pages/newsletter-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "newsletter-submission-success___it",
    path: "/it/iscrizione-newsletter-completata",
    meta: newsletter_45submission_45successlNdcLQOt6WMeta || {},
    component: () => import("/opt/build/repo/pages/newsletter-submission-success.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___en",
    path: "/projects/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___it",
    path: "/it/projects/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "projects___en",
    path: "/projects",
    meta: indexxtMqaql9AYMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: "projects___it",
    path: "/it/projects",
    meta: indexxtMqaql9AYMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: "richiedi-progetto___en",
    path: "/contacts/start-new-project",
    meta: richiedi_45progetto1Nn9GbgCcAMeta || {},
    component: () => import("/opt/build/repo/pages/richiedi-progetto.vue").then(m => m.default || m)
  },
  {
    name: "richiedi-progetto___it",
    path: "/it/contatti/richiedi-un-progetto",
    meta: richiedi_45progetto1Nn9GbgCcAMeta || {},
    component: () => import("/opt/build/repo/pages/richiedi-progetto.vue").then(m => m.default || m)
  },
  {
    name: "solutions-slug___en",
    path: "/solutions/:slug()",
    meta: index8lXtsvPro8Meta || {},
    component: () => import("/opt/build/repo/pages/solutions/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "solutions-slug___it",
    path: "/it/soluzioni/:slug()",
    meta: index8lXtsvPro8Meta || {},
    component: () => import("/opt/build/repo/pages/solutions/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "solutions___en",
    path: "/solutions",
    meta: indexSicrNAjcMxMeta || {},
    component: () => import("/opt/build/repo/pages/solutions/index.vue").then(m => m.default || m)
  },
  {
    name: "solutions___it",
    path: "/it/soluzioni",
    meta: indexSicrNAjcMxMeta || {},
    component: () => import("/opt/build/repo/pages/solutions/index.vue").then(m => m.default || m)
  },
  {
    name: "technology-slug___en",
    path: "/technology/:slug()",
    meta: indexuoDA5dcWGeMeta || {},
    component: () => import("/opt/build/repo/pages/technology/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "technology-slug___it",
    path: "/it/technology/:slug()",
    meta: indexuoDA5dcWGeMeta || {},
    component: () => import("/opt/build/repo/pages/technology/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "technology___en",
    path: "/technology",
    meta: indexicFcACNNRXMeta || {},
    component: () => import("/opt/build/repo/pages/technology/index.vue").then(m => m.default || m)
  },
  {
    name: "technology___it",
    path: "/it/technology",
    meta: indexicFcACNNRXMeta || {},
    component: () => import("/opt/build/repo/pages/technology/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stub0XN034Q7gBMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub0XN034Q7gB
  }
]